import React, { useState } from 'react';
import { MdClose } from 'react-icons/md';
import Loader from "react-loader-spinner";
import '../../assets/tagInputs.css';

const DeliveryModal = ({ t, showModal, loading, handleOk, handleCancel, footerOption1, footerOption2, deliveryTypes }) => {

    const [selectType, setSelectType] = useState('');
    const [tags, setTags] = React.useState([]);
    const addTags = event => {
        if (event.key === "Enter" && event.target.value !== "") {
            setTags([...tags, event.target.value]);
            event.target.value = "";
        }
    };
    const removeTags = index => {
        setTags([...tags.filter(tag => tags.indexOf(tag) !== index)]);
    };

    let options = deliveryTypes.deliveryTypes;

    return(
        <div>
            <div className="modal" style={{display: (showModal ? 'block': '')}}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t("jobsManagement.infoJob.createDeliveryRequest.title")}</h5>
                            <button disabled={loading} type="button" className="close rounded-xl bg-white text-dark border-0 rounded-2" aria-label="Close" onClick={handleCancel}>
                                <MdClose />
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="d-flex flex-column mb-3">
                                <label className="form-label mb-1">{t("jobsManagement.infoJob.createDeliveryRequest.type")}</label>
                                <select className="form-select me-3" value={selectType}  onChange={e => setSelectType(e.target.value)}>
                                    <option value="" disabled={true}>{t("jobsManagement.infoJob.createDeliveryRequest.typePlaceholder")}</option>
                                    {options.map(({ value, lable}) => (<option key={value} value={value}>{lable}</option>))}
                                </select>
                            </div>
                            <div className="d-flex flex-column mb-3">
                                <label className="form-label mb-1">{t("jobsManagement.infoJob.createDeliveryRequest.documents")}</label>
                                <div className="tags-input">
                                    <ul id="tags">
                                        {tags.map((tag, index) => (
                                            <li key={index} className="tag">
                                                <span className='tag-title'>{tag}</span>
                                                <span className='tag-close-icon' onClick={() => removeTags(index)}> x </span>
                                            </li>
                                        ))}
                                    </ul>
                                    <input
                                        type="text"
                                        onKeyUp={event => addTags(event)}
                                        placeholder="Press enter to add tags"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button disabled={loading} type="button" className="btn btn-light-danger font-weight-bold" onClick={handleCancel}>{footerOption2 ? footerOption2 : t("jobsManagement.infoJob.createDeliveryRequest.close")}</button>
                            <button disabled={(selectType.length === 0) || loading} type="button" className="btn btn-primary font-weight-bold d-flex align-items-center" onClick={() => handleOk(selectType, tags)}>{footerOption1 ? footerOption1 : t("jobsManagement.infoJob.createDeliveryRequest.ok")}
                                {loading && <Loader type="Oval" color="#fff" height={20} width={20} style={{marginLeft: '10px'}} />}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop show"></div>
        </div>
    );
};

export default DeliveryModal;